import Vue from "vue";

function formatWISE(value, grand = "", decimalplaces = 8, appendix = "") {
  let formattedValue = 0.0;
  if (!isNaN(parseFloat(value)) && value >= 0) {
    value = parseFloat(value);
    if (grand === "") {
      formattedValue = parseFloat(value);
      // console.log(value)
    } else if (grand === "K") {
      formattedValue = value / 1000.0;
    } else if (grand === "M") {
      formattedValue = value / 1000.0 / 1000.0;
    } else if (grand === "B") {
      formattedValue = value / 1000.0 / 1000.0 / 1000.0;
    } else if (grand === "T") {
      formattedValue = value / 1000.0 / 1000.0 / 1000.0 / 1000.0;
    } else if (grand === "a") {
      grand = "";
      if (value < 1000.0) {
        formattedValue = value;
        grand = "";
      }
      if (value >= 1000.0 && value < 1000.0 * 1000.0) {
        formattedValue = value / 1000.0;
        grand = "K";
      }
      if (value >= 1000.0 * 1000.0 && value < 1000.0 * 1000.0 * 1000.0) {
        formattedValue = value / 1000.0 / 1000.0;
        grand = "M";
      }
      if (value >= 1000.0 * 1000.0 * 1000.0 && value < 1000.0 * 1000.0 * 1000.0 * 1000.0) {
        formattedValue = value / 1000.0 / 1000.0 / 1000.0;
        grand = "B";
      }
      if (value >= 1000.0 * 1000.0 * 1000.0 * 1000.0) {
        formattedValue = value / 1000.0 / 1000.0 / 1000.0 / 1000.0;
        grand = "T";
      }
    }
    formattedValue = formattedValue.toFixed(decimalplaces).toString();
    formattedValue += grand;
  } else {
    formattedValue = value;
  }
  if (appendix !== "") {
    formattedValue += " " + appendix;
  }
  return formattedValue
}

function toInt(value, digits = 0, appendix = "") {
  if (typeof value !== "number") {
    return value;
  }
  let formattedValue = new Intl.NumberFormat(navigator.language, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value);
  if (appendix !== "") {
    formattedValue += " " + appendix;
  }
  return  formattedValue;
}

function toCurrency(value, digits = 0, appendix = "") {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
  let formattedValue = formatter.format(value);
  if (appendix !== "") {
    formattedValue += " " + appendix;
  }
  return  formattedValue;
}

Vue.filter('formatWISE', formatWISE);
Vue.filter('toInt', toInt);
Vue.filter('toCurrency', toCurrency);
